import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from "@mui/material"; // Import for responsive detection

const CTASection = () => {
  const [lightPosition, setLightPosition] = useState({
    top: "50%",
    left: "50%",
  });
  const navigate = useNavigate();
  const location = useLocation();
  
  const isMobile = useMediaQuery('(max-width: 767px)'); // Check if screen is mobile-sized

  // Function to navigate to /bookmeeting
  const handleBookMeeting = () => {
    navigate("/bookmeeting");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Function to move the light randomly within the section
  const moveLightRandomly = () => {
    const randomX = Math.random() * 100; // Random position along the X axis
    const randomY = Math.random() * 100; // Random position along the Y axis
    setLightPosition({ top: `${randomY}%`, left: `${randomX}%` });
  };

  useEffect(() => {
    const interval = setInterval(moveLightRandomly, 2000); // Move light every 2 seconds
    return () => clearInterval(interval); // Clear the interval on component unmount
  }, []);

  const styles = {
    container: {
      backgroundColor: "#17334B",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: isMobile ? "50px 30px" : "90px 20px", // Adjust padding for mobile
      textAlign: "center",
      overflow: "hidden",
      height: isMobile ? "300px" : "400px", // Adjust height for mobile
    },
    movingLight: {
      position: "absolute",
      width: isMobile ? "400px" : "600px", // Adjust light size for mobile
      height: isMobile ? "400px" : "600px",
      background: "radial-gradient(circle, rgba(21, 114, 175, 0.8), transparent 70%)",
      borderRadius: "50%",
      pointerEvents: "none",
      top: lightPosition.top,
      left: lightPosition.left,
      transform: "translate(-50%, -50%)",
      transition: "top 1.5s ease-in-out, left 1.5s ease-in-out",
      zIndex: 0,
    },
    contentWrapper: {
      zIndex: 1,
      position: "relative",
    },
    heading: {
      color: "#FFFFFF",
      fontSize: isMobile ? "17px" : "40px", // Adjust font size for mobile
      fontWeight: "bold",
      marginBottom: isMobile? "15px" : "40px",
      background: "linear-gradient(90deg, #FFFFFF 0%, #ACD5ED 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    subheading: {
      color: "#FFFFFF",
      fontSize: isMobile ? "12px" : "30px", // Adjust font size for mobile
      marginBottom: "25px",
    },
    paragraph: {
      color: "#C5C5C5",
      fontSize: isMobile ? "0.7rem" : "1rem", // Adjust font size for mobile
      marginBottom: "20px",
    },
    button: {
      backgroundColor: "#F4E37B",
      color: "#2D669B",
      padding: isMobile ? "10px 20px" : "15px 30px", // Adjust padding for mobile
      borderRadius: "8px",
      border: "none",
      fontSize: isMobile ? "0.5rem" : "1rem", // Adjust font size for mobile
      cursor: "pointer",
      textDecoration: "none",
      display: "inline-block",
      marginTop: "20px",
    },
  };

  return (
    <div style={styles.container}>
      {/* Light Effect */}
      <div style={styles.movingLight}></div>

      {/* Content */}
      <div style={styles.contentWrapper}>
        <h2 style={styles.heading}>Unleash Maximum Potential Today</h2>
        <h3 style={styles.subheading}>Manage any digital asset with one platform</h3>
        <p style={styles.paragraph}>Get in touch with our team</p>
        <a
          onClick={handleBookMeeting}
          style={styles.button}
        >
          Book a Meeting
        </a>
      </div>
    </div>
  );
};

export default CTASection;
